<template>
  <div>
    <p
      class="text--center"
      style="margin-bottom: 35px;"
    >
      {{ $i18n.t('AUTO_TOPUP.DEACTIVATE.DETAILS.P1') }}
    </p>
    <p class="text--center">
      {{ $i18n.t('AUTO_TOPUP.PRODUCT_INFO.TARIFF_NAME') }}
    </p>
    <p class="text--center">
      <strong>{{ tariffSizeName }}</strong>
    </p>

    <p class="text--center">
      {{ $i18n.t('AUTO_TOPUP.PRODUCT_INFO.PRICE') + durationLowerCase + ":" }}
    </p>
    <p class="text--center">
      <!-- eslint-disable -->
      <strong v-html="tariffPrice" />
      <!-- eslint-enable -->
    </p>

    <submit-button
      id="deactivateAtuSubmitButton"
      :label="this.$i18n.t('AUTO_TOPUP.DEACTIVATE.BUTTON_LABEL')"
      :on-click="redirect"
      :spacing="false"
    />
  </div>
</template>

<script>
  export default {
    name: "DeactivateAutoTopup",
    components: { },
    props: {
      tariffSizeName: {
        type: String,
        required: true
      },
      tariffPrice: {
        type: String,
        required: true
      },
      duration: {
        type: String,
        default: "",
        required: false
      }
    },
    data: function() {
      return {}
    },
    computed: {
      durationLowerCase: function() {
        if (this.duration && this.duration.length > 0) {
          return this.duration.charAt(0).toLowerCase() + this.duration.slice(1);
        } else return this.duration;
      },
    },
    methods: {
      redirect: function() {
        this.$router.push({name: 'deactivateAutoTopupConfirm'});
      }
    }
  }
</script>

<style scoped>

</style>
